<template>
  <div>
    <question-renderer
      :question="src"
      :indicator="indicator"
    ></question-renderer>

    <div class="puzzle-zone">
      <v-fade-transition>
        <v-btn
          v-show="btnShow && !readOnly"
          depressed
          color="primary"
          @click="startGame"
          class="mb-4"
          :disabled="!imgReady"
        >
          <v-icon left>far fa-play</v-icon>เริ่มต้นเกม
        </v-btn>
      </v-fade-transition>
      <v-row no-gutters>
        <v-col cols="4" md="3" v-for="(img, idx) of imgs" :key="`col_${idx}`">
          <v-sheet tile style="padding: 2px">
            <flip-card
              :openable="openable"
              :timeout="1000"
              :pre-timeout="3000"
              :card-data="{ idx: idx }"
              @onMounted="onMounted"
              @onOpen="onOpenCard"
              @onClose="onCloseCard"
              :ref="`card_game_${idx}`"
              :onLoad="onImgLoad"
            >
              <template #front>
                <v-img
                  aspect-ratio="1"
                  src="@/assets/flipcard-default-front.png"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <!-- <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular> -->
                    </v-row>
                  </template>
                </v-img>
              </template>
              <template #back="props">
                <v-img
                  aspect-ratio="1"
                  :src="imgs[idx] || ''"
                  @load="props.load($event, idx)"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>

                  <template v-if="props.showOpened">
                    <v-row
                      no-gutters
                      align="end"
                      class="white--text fill-height"
                    >
                      <v-col>
                        <div class="text-right ma-1">
                          <v-icon
                            color="green"
                            style="font-size: 20px !important"
                            >far fa-check-circle</v-icon
                          >
                        </div>
                      </v-col>
                    </v-row>
                    <!-- <v-overlay :opacity="0.2">
                      <v-icon color="green" style="font-size: 32px !important;">far fa-check-circle</v-icon>
                    </v-overlay> -->
                  </template>
                </v-img>
              </template>
            </flip-card>
          </v-sheet>
        </v-col>
        <template v-if="complementItems > 0">
          <v-col
            style="padding: 2px"
            cols="4"
            md="3"
            v-for="n in complementItems"
            :key="`complement_card_${n}`"
          >
            <v-sheet
              class="fill-height"
              tile
              style="width: 100%"
              color="grey lighten-2"
            ></v-sheet>
          </v-col>
        </template>
      </v-row>
    </div>
  </div>
</template>

<script>
import md5 from "md5";
import EventBus from "@/event-bus";
import QuestionRenderer from "@/components/QuestionRenderer.vue";
import FlipCard from "@/components/FlipCard.vue";
export default {
  props: ["src", "userAnswer", "correctAnswer", "indicator"],
  components: {
    QuestionRenderer,
    FlipCard,
  },
  data: () => ({
    btnShow: true,
    answer: [],
    selectedCard: [],
    openable: false,
    imgs: [],
    imgState: [],
    imgReady: false,
    openedCard: [],
  }),
  watch: {
    answer(val) {
      const data = {
        answer: val,
      };
      this.$emit("interact", data);
    },
    showCorrectAnswer(val) {
      if (val) {
        this.showCorrect();
      }
    },
  },
  computed: {
    totalImg() {
      return this.src.memoryGameQuestion.length;
    },
    complementItems() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        let tmp = 4 - (this.totalImg % 4);
        return tmp == 4 ? 0 : tmp;
      } else {
        let tmp = 3 - (this.totalImg % 3);
        return tmp == 3 ? 0 : tmp;
      }
    },
    showCorrectAnswer() {
      if (
        this.correctAnswer != null &&
        this.correctAnswer.correctPuzzle.length > 0
      ) {
        return true;
      }
      return false;
    },
    readOnly() {
      return this.$store.state.readOnly;
    },
  },
  mounted() {
    this.selectedCard = [];
    this.init();
  },
  methods: {
    init() {
      this.answer = [];
      this.openedCard = [];
      // console.log("init multiple q", this.src);
      if (this.userAnswer != null) {
        this.answer = this.userAnswer;
        this.btnShow = false;

        for (let pair of this.answer) {
          for (let img of pair) {
            let idx = this.src.memoryGameQuestion.indexOf(img);
            this.openedCard.push(img);
          }
        }

        this.$nextTick(() => {
          if (this.readOnly === false) {
            this.openable = true;
          }
        });
      }

      for (let i = 0; i < this.totalImg; i++) {
        this.imgState.push(false);
      }
      this.getImgUrl();
    },
    onMounted(idx) {
      // redraw user answered by using id refer to card and call setFlip
      let img = this.src.memoryGameQuestion[idx];
      if (this.openedCard.indexOf(img) > -1) {
        this.$refs[`card_game_${idx}`][0].setFlip(true, true, true);
      }
    },
    startGame() {
      this.btnShow = false;
      this.showAll();
      this.openable = true;
    },
    onImgLoad(e, idx) {
      this.imgState[idx] = true;
      this.$nextTick(() => {
        this.checkImgReady();
      });
      // this.checkImgReady();
      // console.log(this.imgState);
    },
    checkImgReady() {
      if (this.imgState.indexOf(false) === -1) {
        this.imgReady = true;
      } else {
        this.imgReady = false;
      }
      // console.log(this.imgState.indexOf(false), this.imgState);
    },
    onImgError(e, idx) {
      this.imgState[idx] = false;
    },
    getAnswer() {
      return this.answer;
    },
    onOpenCard(idx) {
      if (this.selectedCard.length == 0) {
        this.selectedCard.push(idx);
      } else {
        // lock first
        this.$refs[`card_game_${this.selectedCard[0]}`][0].lock();
        // matching img process
        let matched = false;
        // console.log(this.selectedCard[0], idx);
        // test logic
        let hashForward = md5(
          this.src.memoryGameQuestion[this.selectedCard[0]] +
            this.src.memoryGameQuestion[idx]
        );
        if (this.src.hashset.indexOf(hashForward) > -1) {
          matched = true;
        } else {
          let hashBackward = md5(
            this.src.memoryGameQuestion[idx] +
              this.src.memoryGameQuestion[this.selectedCard[0]]
          );
          if (this.src.hashset.indexOf(hashBackward) > -1) {
            matched = true;
          }
        }

        if (matched) {
          this.$refs[`card_game_${idx}`][0].lock();
          let userAnswer = [];
          userAnswer.push(this.src.memoryGameQuestion[this.selectedCard[0]]);
          userAnswer.push(this.src.memoryGameQuestion[idx]);
          this.answer.push(userAnswer);

          // reset selection
          this.selectedCard = [];

          // check auto end
          // if (this.isFinish() === true) {
          //   this.done();
          // }
          this.sendAnswer();
        } else {
          // close couple card
          setTimeout(() => {
            // unlock first and close it because not matched
            this.$refs[`card_game_${this.selectedCard[0]}`][0].unlock();
            this.$refs[`card_game_${this.selectedCard[0]}`][0].close();

            this.$refs[`card_game_${idx}`][0].close();
            this.selectedCard = [];
          }, 750);
        }
      }
    },
    onCloseCard(id) {
      if (this.selectedCard.length == 1) {
        this.selectedCard = [];
      } else {
      }
    },
    isFinish() {
      if (this.answer.length == this.totalImg / 2) {
        return true;
      } else {
        return false;
      }
    },
    sendAnswer() {
      const data = {
        answer: this.answer,
      };
      this.$emit("interact", data);
    },
    showAll() {
      for (let idx = 0; idx < this.totalImg; idx++) {
        this.$refs[`card_game_${idx}`][0].show();
      }
    },
    showCorrect() {
      // console.log(this.showCorrectAnswer);
      for (let idx = 0; idx < this.totalImg; idx++) {
        this.$refs[`card_game_${idx}`][0].setFlip(true, true, null);
      }
    },
    getImgUrl() {
      let req = [];
      //     return await get(`/uploadfile/preview/image`, {
      //   idimage: idimage
      // })
      const config = {
        headers: {
          "x-session-token": this.$store.state.token,
          "server-name": this.$store.state.serverName,
        },
      };
      for (let img of this.src.memoryGameQuestion) {
        let xhr = this.$http.get(
          `${this.$store.state.apiDekNerd}/uploadfile/getfile/puzzle?idimage=${img}`,
          config
        );
        req.push(xhr);
      }

      Promise.all(req)
        .then((responses) => {
          for (let resp of responses) {
            this.imgs.push(resp.data.result);
          }
        })
        .catch((err) => {
          // err
          console.error(err);
        });
    },
  },
};
</script>

<style>
</style>